module.exports = __webpack_public_path__ + "img/african-american-medical-doctor-man-with-mask-isolated-gray-background.3fc73968.png";